import { CircleUser } from 'lucide-react';

import { useLoadProfileImageQuery } from '../../../store/index.js';

interface Props {
    uid: string;
}

const ProfilePicture: FC<Props> = ({ uid }) => {
    const { data: profileImageUrl } = useLoadProfileImageQuery({ uid }, { skip: !uid });

    return (
        <div className="profile-picture">
            {profileImageUrl ? (
                <img src={profileImageUrl} alt="avatar icon" className="profile-picture-icon" />
            ) : (
                <CircleUser className="profile-picture-placeholder" />
            )}
        </div>
    );
};

export default ProfilePicture;
